import { render, staticRenderFns } from "./FireBeginQuestion.vue?vue&type=template&id=206e0055&scoped=true"
import script from "./FireBeginQuestion.vue?vue&type=script&lang=ts"
export * from "./FireBeginQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206e0055",
  null
  
)

export default component.exports